import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  headerInnerContainer: {
    marginLeft: theme.spacing(0.5),
  },
}))
